import { InjectionToken } from '@angular/core';

import { AnalyticFormSettingsInterface } from '../models';

export const ANALYTICS_FORM_SETTINGS = new InjectionToken<AnalyticFormSettingsInterface>('ANALYTICS_FORM_SETTINGS');
